





























































import Vue, { PropType } from 'vue';
import { CourseraCategory, CourseraSubCategory } from '~/models';
import { directive as onClickaway } from 'vue-clickaway';

interface SubCategory extends CourseraSubCategory {
    url: string;
}

export default Vue.extend({
    name: 'CourseraCategories',
    directives: { onClickaway },
    props: {
        loading: {
            type: Boolean,
            required: true,
        },
        categories: {
            type: Array as PropType<CourseraCategory[]>,
            required: true,
        },
        programUrl: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            openCategory: null as CourseraCategory | null,
            dropdownPos: { top: '0px', left: '0px', minWidth: '0px' },
            canScroll: { left: false, right: false },
        };
    },
    computed: {
        categoryUrl(): string {
            if (!this.openCategory) return '#';
            return this.addUrlParams(`${this.programUrl}/${this.openCategory.id}`);
        },
        selectedSubCategories(): SubCategory[] | null {
            if (!this.openCategory) return null;

            const cat = this.categories.find(cat => cat.id === this.openCategory!.id);
            if (!cat) return null;

            return cat.subCategories.map(sub => ({
                ...sub,
                url: this.addUrlParams(`${this.programUrl}/${cat.id}/${sub.id}`),
            }));
        },
    },
    methods: {
        toggleDropdown(category: CourseraCategory) {
            if (!!this.openCategory && category.id === this.openCategory.id)
                this.openCategory = null;
            else {
                const el = this.$refs[category.id];
                if (Array.isArray(el) && el.length) {
                    const rect = (el as Element[])[0].getBoundingClientRect();
                    this.dropdownPos = {
                        left: rect.left + 'px',
                        top: rect.top + rect.height + 8 + 'px',
                        minWidth: rect.width + 'px',
                    };
                    this.openCategory = category;
                }
            }
        },
        addUrlParams(url: string) {
            return url + '?authProvider=highered';
        },
        handleScroll(dir: 'left' | 'right') {
            this.openCategory = null;

            const cats = this.$refs['category-scroller'] as Element;
            if (!cats) return;

            const { scrollLeft, scrollWidth, clientWidth } = cats;
            if (clientWidth >= scrollWidth) return;

            let newScroll = -1;

            if (dir === 'left' && scrollLeft > 0) newScroll = Math.max(scrollLeft - clientWidth, 0);
            else if (dir === 'right' && scrollLeft + clientWidth < scrollWidth)
                newScroll = Math.min(scrollLeft + clientWidth, scrollWidth - clientWidth);

            if (newScroll < 0) return;
            cats.scrollLeft = newScroll;

            this.calculateCanScroll(newScroll);
        },
        calculateCanScroll(newScroll?: number) {
            const cats = this.$refs['category-scroller'] as Element;
            if (!cats) return;

            const { scrollLeft, scrollWidth, clientWidth } = cats;
            if (clientWidth >= scrollWidth) {
                this.canScroll = {
                    left: false,
                    right: false,
                };
                return;
            }

            const scroll = typeof newScroll === 'undefined' ? scrollLeft : newScroll;
            this.canScroll = {
                left: scroll > 0,
                right: scroll + clientWidth < scrollWidth,
            };
        },
        away() {
            !!this.openCategory && (this.openCategory = null);
        },
    },
    watch: {
        loading(value: boolean) {
            if (value) return;
            setTimeout(() => this.calculateCanScroll(), 100);
        },
    },
});
